// src/components/Footer.jsx
import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="/4_20251023_102853_0003.svg"
              alt="Ofanda Africa logo"
              className="h-44 -mt-16 -mb-8 object-contain"
            />
          </div>

          {/* Quick Links */}
          <div className=''>
            <ul className="flex items-center justify-left space-x-10">
              <li><Link to="/about" className="text-gray-300 hover:text-ofanda-indigo transition-colors duration-300">About</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-ofanda-indigo transition-colors duration-300">Services</Link></li>
              <li><Link to="/insights" className="text-gray-300 hover:text-ofanda-indigo transition-colors duration-300">Insights</Link></li>
              <li><Link to="/media" className="text-gray-300 hover:text-ofanda-indigo transition-colors duration-300">Media</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-ofanda-indigo transition-colors duration-300">CSR</Link></li>
            </ul>
          </div>

        </div>

        <div className="flex justify-between items-center border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <div>
            <p>&copy; {new Date().getFullYear()} Ofanda Africa.<br></br> All rights reserved.</p>
          </div>

          <div className="flex space-x-4">
            <a href="https://www.linkedin.com/company/ofanda-africa/" className="text-gray-400 hover:text-ofanda-indigo transition-colors duration-300">
              <span className="sr-only">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
              </svg>
            </a>
            <a href="mailto:info@ofandaafrica.com" className="text-gray-400 hover:text-ofanda-indigo transition-colors duration-300">
              <span className="sr-only">X</span>
              <svg className='h-6 w-6' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="48" height="48">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <path d="m2 7 10 7 10-7"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer






